import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import Loader from './Loader';

class CartList extends Component {

	getCurrency() {		
		const { currency } = this.props.shopStore;		
		return currency.get();
    }

    renderListings() {
        const listings = [];
        const { cartItems } = this.props.shopStore;
        for (const key of cartItems.keys()) {
            const item = cartItems.get(key);
            listings.push(
                <li key={key} className="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                        <h6 className="my-0">{item.name}</h6>
                        <small className="text-muted">{item.sku}</small>
                    </div>
                    <span className="text-muted">{this.getCurrency().symbol + item.price}</span>
                </li>                
            )
        }
        if (!cartItems.size) {
            listings.push(
                <li key="emptyCartKey" className="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                        <h6 className="my-0 text-muted">Your cart is empty.</h6>                        
                    </div>                    
                </li>                
            )            
        }
        return listings;
      }    

    render() {
        const { shopStore } = this.props;
        const { cartItems } = shopStore;
        if (shopStore.processingCart.get()) {
            return <span>Loading your cart... <Loader /></span>
        }
        return (
            <span>                
                <h4 className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted">Your Cart</span>
                    <span className="badge badge-secondary badge-pill">{cartItems.size}</span>
                </h4>
                <ul className="list-group mb-3">
                    {this.renderListings()}
                    <li className="list-group-item d-flex justify-content-between">
                        <span>Total ({this.getCurrency().code})</span>
                        <strong>{this.getCurrency().symbol + shopStore.getTotal()}</strong>
                    </li>
                </ul>                
            </span>
        );
    }

}

export default inject('shopStore')(observer(CartList));



// WEBPACK FOOTER //
// ./src/components/CartList.js